import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import { mockTeamData } from '../mock';
import '../styles/Team.css';

const Team = () => {
  return (
    <section id="team" className="team-section">
      <div className="team-container">
        <div className="team-header">
          <div className="section-badge">
            <span>EKİP</span>
          </div>
          <h2 className="section-title display-large">Ekibimiz</h2>
          <p className="section-description body-medium">
            Farklı disiplinlerden gelen uzman mühendislerimiz, pasif radar teknolojisini 
            geliştirmek için bir araya geldi.
          </p>
        </div>
        
        <div className="team-grid">
          {mockTeamData.map((member, index) => (
            <div key={index} className="team-card dark-hover">
              <div className="team-card-image">
                <img src={member.image} alt={member.name} />
                <div className="team-card-overlay">
                  <div className="team-social">
                    <a href={member.linkedin} className="social-link" target="_blank" rel="noopener noreferrer">
                      <Linkedin size={20} />
                    </a>
                    <a href={`mailto:${member.email}`} className="social-link">
                      <Mail size={20} />
                    </a>
                  </div>
                </div>
              </div>
              <div className="team-card-content">
                <h3 className="team-name heading-3">{member.name}</h3>
                <div className="team-role body-small">{member.role}</div>
                <p className="team-bio body-small">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;

